module.exports = __webpack_public_path__ + "static/media/AT_0631_001_DC_F_FI_19-07-08_Cuvitru.970428b3.pdf";